export interface DealAttributes {
  name: string | null
  expose_received: number | null
  structure?: string | null
  procedure?: string | null
  asking_price: number | null
  asking_price_type: string | null
  total_asking_price?: number | null
  asking_price_per_area?: number | null
  main_picture?: string | null
  offer_received?: number | null
  broker_name?: string | null
  broker_contact?: string | null
  broker_phone?: string | null
  broker_email?: string | null
  seller_name?: string | null
  seller_contact?: string | null
  seller_phone?: string | null
  seller_email?: string | null
  forward?: string | null
  yield_value?: number | null
  multiplier?: number | null
  created_at?: number | null
  updated_at?: number | null
  courtage?: number | null
  locations_count?: number | null
  assets_count?: number | null
  free_commision?: boolean | null
  bid_request: boolean | null
  captain_reference?: string | null
  status: string
  canceled_reason?: string | null
  status_date?: number | null
  canceled_comment_id?: string | null
  risk_profile?: string | null
  currency_exchange_rates?: { [key: string]: number } | null
  company_ref_uuid?: string | null
  currency_code?: string | null
  measured_by?: string | null
  total_net_rent_monthly?: number | null
  total_area?: number | null
  main_type_of_use?: string | null
}

export const dealAttributes = [
  'name',
  'expose_received',
  'structure',
  'procedure',
  'asking_price',
  'asking_price_type',
  'total_asking_price',
  'asking_price_per_area',
  'main_picture',
  'offer_received',
  'broker_name',
  'broker_contact',
  'broker_phone',
  'broker_email',
  'courtage',
  'seller_name',
  'seller_contact',
  'seller_phone',
  'seller_email',
  'forward',
  'yield_value',
  'multiplier',
  'created_at',
  'updated_at',
  'locations_count',
  'assets_count',
  'free_commision',
  'bid_request',
  'captain_reference',
  'status',
  'canceled_reason',
  'status_date',
  'canceled_comment_id',
  'risk_profile',
  'currency_exchange_rates',
  'company_ref_uuid',
  'currency_code',
  'measured_by',
  'total_net_rent_monthly',
  'total_area',
  'main_type_of_use',
];
